// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
let ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
let ContentBox__Jsx3 = require("../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let NotificationSettings = require("./NotificationSettings.bs.js");
let EmailPreferencesPageRelayQuery_graphql = require("../../__generated__/EmailPreferencesPageRelayQuery_graphql.bs.js");

let convertVariables = EmailPreferencesPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = EmailPreferencesPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = EmailPreferencesPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, EmailPreferencesPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, EmailPreferencesPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(EmailPreferencesPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(EmailPreferencesPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(EmailPreferencesPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(EmailPreferencesPageRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function EmailPreferencesPageRelay(props) {
  let data = use(undefined, undefined, undefined, undefined);
  let chapter = data.currentChapterV5;
  let tmp;
  if (chapter !== undefined) {
    let userNotificationSettings = data.userNotificationSettingsV5;
    tmp = userNotificationSettings !== undefined ? JsxRuntime.jsx(NotificationSettings.make, {
        userNotificationSettings: userNotificationSettings.fragmentRefs,
        chapter: chapter.fragmentRefs
      }) : JsxRuntime.jsx(ErrorComponent.make, {
        message: "We encountered an error loading your preferences. Please refresh and try again later..."
      });
  } else {
    tmp = JsxRuntime.jsx(ErrorComponent.make, {
      message: "We encountered an error loading your preferences. Please refresh and try again later..."
    });
  }
  return JsxRuntime.jsxs(ContentBox__Jsx3.make, {
    paddingFull: true,
    hasShadow: true,
    children: [
      JsxRuntime.jsx(PageUITitle.make, {
        title: "Email Notifications"
      }),
      tmp
    ]
  });
}

let make = EmailPreferencesPageRelay;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
